export enum Errors {
    AI_MODULES_NOT_INITIALIZED = 'AI_MODULES_NOT_INITIALIZED',
    USAGE_DATA_NOT_FOUND = 'USAGE_DATA_NOT_FOUND',
    EMAIL_CONFIG_NOT_DEFINED = 'EMAIL_CONFIG_NOT_DEFINED',
    STREAM_FAILED = 'STREAM_FAILED',
    MODEL_NOT_FOUND = 'MODEL_NOT_FOUND',
    INVALID_PROFFESSION = 'INVALID_PROFFESSION',
    CONVERSATION_STREAM_ERROR = 'CONVERSATION_STREAM_ERROR',
    UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
    ROLE_LIMIT_EXCEED = 'ROLE_LIMIT_EXCEED',
    PARENT_MESSAGE_NOT_FOUND = 'PARENT_MESSAGE_NOT_FOUND',
    API_KEY_MISSING = 'API_KEY_MISSING',
    API_KEY_INVALID = 'API_KEY_INVALID',
    INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
    INVALID_TOKEN = 'INVALID_TOKEN',
    USER_NOT_FOUND = 'USER_NOT_FOUND',
    INTERNAL_ERROR = 'INTERNAL_ERROR',
    EMAIL_ALREADY_EXISTS = 'EMAIL_ALREADY_EXISTS',
    EMAIL_NOT_VERIFIED = 'EMAIL_NOT_VERIFIED',
    EMAIL_REGISTERED_WITH_ANOTHER_METHOD = 'EMAIL_REGISTERED_WITH_ANOTHER_METHOD',
    SMTP_CONNECTION_FAILED = 'SMTP_CONNECTION_FAILED',
    EMAIL_SENDING_FAILED = 'EMAIL_SENDING_FAILED',
    INVALID_EMAIL_CONFIG = 'INVALID_EMAIL_CONFIG',
    INVALID_RECIPIENT = 'INVALID_RECIPIENT',
    TEMPLATE_RENDERING_ERROR = 'TEMPLATE_RENDERING_ERROR',
    RATE_LIMIT_EXCEEDED = 'RATE_LIMIT_EXCEEDED',
    WEB_APP_URL_MISSING = 'WEB_APP_URL_MISSING',
    AUTH_TOKEN_CREATION_FAILED = 'AUTH_TOKEN_CREATION_FAILED',
    TOKEN_CREATION_FAILED = 'TOKEN_CREATION_FAILED',
    AUTH_CREATION_FAILED = 'AUTH_CREATION_FAILED',
    TOKEN_OR_DEVICE_INVALID = 'TOKEN_OR_DEVICE_INVALID',
    INVALID_REFRESH_TOKEN = 'INVALID_REFRESH_TOKEN',
    USER_VERIFICATION_FAILED = 'USER_VERIFICATION_FAILED',
    USER_UPDATE_FAILED = 'USER_UPDATE_FAILED',
    AUTH_UPDATE_FAILED = 'AUTH_UPDATE_FAILED',
    CHAT_RESPONSE_FAILED = 'CHAT_RESPONSE_FAILED',
    CONVERSATION_CREATION_FAILED = 'CONVERSATION_CREATION_FAILED',
    MESSAGE_NOT_FOUND = 'MESSAGE_NOT_FOUND',
    DOCUMENT_LIMIT_EXCEEDED = 'DOCUMENT_LIMIT_EXCEEDED',
    //
    BAD_REQUEST = 'BAD_REQUEST',
    UNAUTHORIZED = 'UNAUTHORIZED',
    PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
    FORBIDDEN = 'FORBIDDEN',
    NOT_FOUND = 'NOT_FOUND',
    METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
    NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
    PROXY_AUTHENTICATION_REQUIRED = 'PROXY_AUTHENTICATION_REQUIRED',
    REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
    CONFLICT = 'CONFLICT',
    GONE = 'GONE',
    LENGTH_REQUIRED = 'LENGTH_REQUIRED',
    PRECONDITION_FAILED = 'PRECONDITION_FAILED',
    PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
    URI_TOO_LONG = 'URI_TOO_LONG',
    UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE',
    REQUESTED_RANGE_NOT_SATISFIABLE = 'REQUESTED_RANGE_NOT_SATISFIABLE',
    EXPECTATION_FAILED = 'EXPECTATION_FAILED',
    I_AM_A_TEAPOT = 'I_AM_A_TEAPOT',
    MISDIRECTED = 'MISDIRECTED',
    UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
    FAILED_DEPENDENCY = 'FAILED_DEPENDENCY',
    PRECONDITION_REQUIRED = 'PRECONDITION_REQUIRED',
    TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
    INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
    NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
    BAD_GATEWAY = 'BAD_GATEWAY',
    SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
    GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
    HTTP_VERSION_NOT_SUPPORTED = 'HTTP_VERSION_NOT_SUPPORTED',
  }